// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2KnP2","title":"Info_title__1jdjN","links":"Info_links__2E2bH","link":"Info_link__v4CUP","logo":"Info_logo__2bH1E"};